import React from 'react';
import { cn } from './utils/cn';
import { PokerChip } from './PokerChip';
import { MessageCircle, Trophy, History } from 'lucide-react';

/**
 * Полоса под столом: декоративные фишки + STACK + иконки (как в референсе).
 */
export function PlayerStackBar({ stackAmount, className, balanceFx }) {
  const formatted = Number(stackAmount || 0).toLocaleString('ru-RU');

  return (
    <div
      className={cn(
        'flex items-center justify-between rounded-lg border border-border bg-card/60 px-4 py-2 backdrop-blur-md',
        balanceFx === 'gain' && 'poker-fx-win-aura ring-1 ring-emerald-500/30',
        balanceFx === 'loss' && 'ring-1 ring-red-500/25',
        className
      )}
    >
      <div className="flex items-center gap-3">
        <div className="flex -space-x-1">
          <PokerChip value={5000} size="sm" />
          <PokerChip value={1000} size="sm" />
          <PokerChip value={100} size="sm" />
        </div>
        <div className="flex flex-col">
          <span className="text-[9px] uppercase tracking-wide text-muted-foreground">Stack</span>
          <span
            className={cn(
              'font-mono text-sm font-bold text-neon-cyan',
              balanceFx === 'gain' && 'poker-fx-stack-gain',
              balanceFx === 'loss' && 'poker-fx-stack-loss'
            )}
          >
            {formatted} SEKA
          </span>
        </div>
      </div>

      <div className="flex gap-1">
        <button
          type="button"
          className="flex h-8 w-8 items-center justify-center rounded-md text-muted-foreground hover:bg-muted/40 hover:text-foreground"
          aria-label="Чат"
        >
          <MessageCircle className="h-4 w-4" />
        </button>
        <button
          type="button"
          className="flex h-8 w-8 items-center justify-center rounded-md text-neon-gold hover:bg-muted/40"
          aria-label="Турниры"
        >
          <Trophy className="h-4 w-4" />
        </button>
        <button
          type="button"
          className="flex h-8 w-8 items-center justify-center rounded-md text-muted-foreground hover:bg-muted/40 hover:text-foreground"
          aria-label="История"
        >
          <History className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
